// extracted by mini-css-extract-plugin
export default {"checkout_form":"Update_checkout_form__YHkvN"};